// Código de indicação: só letras/números, sempre MAIÚSCULO, 3–20 caracteres — mesma regra do
// backend (AmbassadorController). Normalizar já na digitação evita `gabi10` e `GABI10` virarem
// dois códigos diferentes.
export const normalizeReferralCode = (value) =>
  String(value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20);

export const isValidReferralCode = (value) => /^[A-Z0-9]{3,20}$/.test(value);
